import React, { useContext, useEffect, useState, useCallback } from 'react'
import { NavigationContext } from '../../../context/navigation-context'
import { Link } from 'react-router-dom'
import useFetch from '../../../hooks/fetchMSSQL-hook'
import useForm from '../../../hooks/form-hook'
import ProductsTable from './components/ProductsTable'
import { API_URL } from '../../../config/config'
import ProductForm from '../../../components/Modals/ProductForm'
import SearchFilter from '../../../components/Filter/SearchFilter'
import sampleProduct from '../../../assets/images/sample-product.svg'

const Products = () => {
  const { fetchMssqlApi } = useFetch();
  const { setHeaderData } = useContext(NavigationContext);
  const { form, openForm, closeForm } = useForm();

  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);

  const defaultFilter = {
    page: 1,
    rowsPerPage: 50,
    sortBy: "none",
    eanPName: "",
    productName: "",
    productId: null,
    productGroupName: "",
    productGroupId: null,
    VATName: "",
    VATCode: null,
    depositId: null,
    depositName: "",
    isActive: "true",
    isIngredient: "null",
    productTags: { id: [], name: [] }
  }

  const [filter, setFilter] = useState(defaultFilter);
  const [settingsFilter, setSettingsFilter] = useState();

  const parseThreeState = (val) => {
    if (val === "true") return true;
    if (val === "false") return false;
    return null;
  };

  const sortDefaults = {
    Image: "ASC",
    EAN: "ASC",
    Name: "ASC",
    IsActive: "DESC",
    IsIngredient: "DESC",
    IngredientTypeName: "ASC",
    IngredientQuantity: "DESC",
    VATName: "ASC",
    DepositName: "ASC",
  };

const handleHeaderSort = (field) => {
    const [curField, curDirRaw] = String(filter.sortBy || "none").split("|");
    const curDir = (curDirRaw || "").toUpperCase();
    let sortBy;
    let sortByName=""
    if (curField !== field) {sortBy = `${field}|DESC`;
    } else if (curDir === "DESC") {sortBy = `${field}|ASC`;
    } else if (curDir === "ASC") {sortBy = "none";
    } else sortBy = `${field}|DESC`;
    const next = { ...filter, sortBy, page: 1 };
    setFilter(next);
    searchProducts(next, settingsFilter.rowsPerPage, 1, true);
  };

  const reportList = [
    { reportId: 68, reportColor: "danger" },
    { reportId: 100, reportColor: "primary" }
  ];

  const getProductIdsByTags = (productTagIds) => {
    return new Promise((resolve, reject) => {
      fetchMssqlApi(
        "getProductIdsByTags",
        { method: "POST", hideNotification: true, data: { productTagIds } },
        (response) => resolve(JSON.stringify(response.map(Number).filter(Number.isFinite)) || "[]"),
        (err) => reject(err)
      );
    });
  };

  const searchProducts = async (f, pageSize, page) => {
    let rowsPerPage = settingsFilter?.rowsPerPage ?? 100;
    if (pageSize != null || pageSize != undefined) rowsPerPage = pageSize;
    const pageNo = Math.max(1, Number(page ?? f?.page) || 1);

    let productIds = "[]";
    if (f?.productTags?.id?.length > 0) productIds = await getProductIdsByTags(f.productTags.id);
    if (f?.productId) {
      const arr = JSON.parse(productIds);
      arr.push(Number(f.productId));
      productIds = JSON.stringify(arr);
    }

    fetchMssqlApi('products', {
      method: "POST",
      hideNotification: true,
      showLoader: true,
      data: {
        isIngredient: parseThreeState(f?.isIngredient),
        EAN: f?.EAN,
        productId: productIds,
        VATCode: f?.VATCode,
        isActive: parseThreeState(f?.isActive),
        depositId: f?.depositId,
        pageNo,
        pageSize: rowsPerPage,
        sortBy: f?.sortBy
      }
    }, (res) => {
      setProducts(res || []);
    });
  };

  const getCategories = () => {
    fetchMssqlApi('categories', {method: "POST", hideNotification: true}, (res) => {
      setCategories(res || []);
    });
  };

  const handleSearchFilterChange = useCallback((f) => {
    setFilter(prev =>
      JSON.stringify(prev || {}) === JSON.stringify(f || {}) ? prev : f
    );
  }, []);

  useEffect(() => {
    setHeaderData({ text: "Produkty" });
  }, [setHeaderData]);

  useEffect(() => {
    if (process.env.REACT_APP_LOCAL_DB === "true") {
      searchProducts();
      getCategories();
    }
  }, []);
  return (
    <div className="container-fluid p-0 filter-icon-fix">
      <ul className="nav nav-tabs machine-tabs mb-1">
        <li className="nav-item">
          <Link to="/products">
            <button className="nav-link btn active" tabIndex="0">
              Produkty
            </button>
          </Link>
        </li>

        {process.env.REACT_APP_LOCAL_DB === "false" && (
          <li className="nav-item">
            <Link to="/recipes">
              <button className="nav-link btn" tabIndex="0">
                Receptury
              </button>
            </Link>
          </li>
        )}

        <li className="nav-item">
          <Link to="/categories">
            <button className="nav-link btn" tabIndex="0">
              Kategorie
            </button>
          </Link>
        </li>

        {process.env.REACT_APP_LOCAL_DB === "false" && (
          <li className="nav-item">
            <Link to="/deposits">
              <button className="nav-link btn" tabIndex="0">
                Kaucje
              </button>
            </Link>
          </li>
        )}
      </ul>
      {process.env.REACT_APP_LOCAL_DB === "false" && (
        <SearchFilter
          filterName={"product"}
          defaultFilter={defaultFilter}
          reportList={reportList}
          searchFilter={filter}
          onFilterChange={handleSearchFilterChange}
          onSettingsChange={(s) => setSettingsFilter(s)}
          search={searchProducts}
          totalCount={products.length}
          forNow
        />
        )}
        <ProductsTable
          products={products}
          API_URL={API_URL}
          openForm={openForm()}
          sampleProduct={sampleProduct}
          sortBy={filter.sortBy}
          handleHeaderSort={handleHeaderSort}
        />
        {form && (
          <ProductForm
            form={form}
            handleClose={closeForm}
            sampleProduct={sampleProduct}
            onAdded={() => searchProducts(filter, settingsFilter?.rowsPerPage, 1)}
          />
        )}
    </div>
  );
};

export default Products;